module.exports = __webpack_public_path__ + "img/link.ec216936.jpg";